
import {Component, Prop, Vue} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {CartEvents, SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

@Component({
  name: 'catalog-product-add-to-cart',
  components: {
    ...ServiceContainer().getComponents(),
    'catalog-product-add-to-cart-modal': () => import('./ProductAddToCartModal.vue'),
  },
})

export default class extends Vue {
  @Prop({required: true}) private product: object;
  @Prop({required: false}) private type: string;
  @Prop({required: false, default: false}) readonly hideModal: boolean;
  @Prop({required: false, default: false}) readonly noReload: boolean;

  @Prop({required: false, default: null}) private recommendationIdentifier: null | string;

  private showModal: boolean = false;
  private addToCartMessage: object = {};

  private classMessage: string = '';
  private productMessage: string = '';

  private async addToQuoteAction(): Promise<void> {
    this.classMessage = '--loading';
    this.productMessage = this.product['sku'];

    try {
      await this.$store.dispatch('Quote/addQuoteItem', {
        sku: this.product['sku'],
        qty: 1,
      });

      if (this.product['bundle_sku_free_product']) {
        await this.$store.dispatch('Quote/addQuoteItem', {
          sku: this.product['bundle_sku_free_product'],
          qty: 1
        });
      }
    } catch ({response}) {
      this.addToCartMessage = response.data;
      this.addToCartErrorMessageHandler();
      return;
    }

    this.addToCartSuccessMessage();

    SolarDataLayer.init().addAddToCart(this.product, CartEvents.ADD, 1);

    await this.$store.dispatch('Quote/fetchQuote');
  }

  private addToCartErrorMessageHandler(): void {
    this.classMessage = '--danger';
    this.productMessage = this.product['sku'];

    setTimeout(() => {
      this.classMessage = '';
      this.productMessage = '';
    }, 3000);
  }

  private addToCartSuccessMessage(): void {
    this.classMessage = '--success';
    this.productMessage = this.product['sku'];

    if ( ! this.hideModal) {
      this.showModal = true;
    } else {
      if ( ! this.noReload) {
        window.location.reload();
      }
    }

    setTimeout(() => {
      this.classMessage = '';
      this.productMessage = '';
    }, 3000);
  }

  private get isB2B(): boolean {
    return this.$store.state['GlobalData']['isB2B'];
  }

  private get notSaleable(): boolean {
    return this.product['not_saleable'] || false;
  }
}
